import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

import { Main, Voltar } from '../styles/GlobalStyled.js'

export default function Home() {
  const [tamAnel, setTamAnel] = useState(5)

  const [aro, setAro] = useState(10)

  useEffect(() => {
    if (tamAnel < 5.1) {
      setAro('Seu aro é: 10')
    } else if (tamAnel < 5.2) {
      setAro('Seu aro é: 11')
    } else if (tamAnel < 5.3) {
      setAro('Seu aro é: 12')
    } else if (tamAnel < 5.4) {
      setAro('Seu aro é: 13')
    } else if (tamAnel < 5.5) {
      setAro('Seu aro é: 14')
    } else if (tamAnel < 5.6) {
      setAro('Seu aro é: 15')
    } else if (tamAnel < 5.7) {
      setAro('Seu aro é: 16')
    } else if (tamAnel < 5.8) {
      setAro('Seu aro é: 17')
    } else if (tamAnel < 5.9) {
      setAro('Seu aro é: 18')
    } else if (tamAnel < 6.0) {
      setAro('Seu aro é: 19')
    } else if (tamAnel < 6.1) {
      setAro('Seu aro é: 20')
    } else if (tamAnel < 6.2) {
      setAro('Seu aro é: 21')
    } else if (tamAnel < 6.3) {
      setAro('Seu aro é: 22')
    } else if (tamAnel < 6.4) {
      setAro('Seu aro é: 23')
    } else if (tamAnel < 6.5) {
      setAro('Seu aro é: 24')
    } else if (tamAnel < 6.6) {
      setAro('Seu aro é: 25')
    } else if (tamAnel < 6.7) {
      setAro('Seu aro é: 26')
    } else if (tamAnel < 6.8) {
      setAro('Seu aro é: 27')
    } else if (tamAnel < 6.9) {
      setAro('Seu aro é: 28')
    } else if (tamAnel < 7.0) {
      setAro('Seu aro é: 29')
    } else if (tamAnel < 7.1) {
      setAro('Seu aro é: 30')
    } else if (tamAnel < 7.2) {
      setAro('Seu aro é: 31')
    } else if (tamAnel < 7.3) {
      setAro('Seu aro é: 32')
    } else if (tamAnel < 7.4) {
      setAro('Seu aro é: 33')
    } else if (tamAnel < 7.5) {
      setAro('Seu aro é: 34')
    } else {
      setAro('Seu aro é: 35')
    }
  }, [tamAnel])

  return (
    <Main>
      <Container>
        <Instrucoes>
          <h2>Agora é fácil!</h2>
          <h3>
            Você só precisa arrastar a bolinha azul até que indique a distância
            que você acabou de medir no passo anterior.
          </h3>
        </Instrucoes>

        <h3>{tamAnel} cm</h3>
        <input
          type="range"
          name="tamanho"
          min="5"
          max="7.5"
          step="0.1"
          value={tamAnel}
          onChange={(e) => setTamAnel(e.target.value)}
        />
        <h1>{aro}</h1>

        <Footer>
          <a
            href="https://www.usemaclah.com.br/"
            target="_blank"
            rel="noreferrer"
          >
            <button>Ir para a loja on-line</button>
          </a>
          <Link to={'/instrucao-sem-anel'}>
            <Voltar>Voltar</Voltar>
          </Link>
        </Footer>
      </Container>
    </Main>
  )
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 90vw;
  height: 800px;
  /* background: rgba(255, 255, 255, 0.75);
  box-shadow: 0 8px 32px 0 rgba(149, 114, 39, 0.37);
  backdrop-filter: blur(5.5px);
  -webkit-backdrop-filter: blur(5.5px);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.18); */
  position: relative;
  color: #0d47a1;

  @media (min-width: 1300px) {
    height: 90vh;
  }

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  h2,
  h1 {
    font-weight: bold;
    line-height: 50px;
    font-size: 30px;

    @media (min-width: 1300px) {
      font-size: 4vw;
      line-height: 150px;
    }
  }

  h1 {
    font-weight: normal;

    @media (min-width: 1300px) {
      font-size: 3vw;
      line-height: 15vh;
    }
  }

  h3 {
    line-height: 26px;
    font-size: 16px;
    font-size: 16px;
    text-align: justify;

    @media (min-width: 1300px) {
      font-size: 2vw;
      line-height: 6vh;
    }
  }

  input {
    -webkit-appearance: none;
    appearance: none;
    border-radius: 20px;
    background: rgba(33, 150, 243, 0.3);
    outline: none;
    width: 80vw;
    height: 10px;
    margin: 10px 20px;
  }

  input::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #0d47a1;
    cursor: pointer;
  }

  input::-moz-range-thumb {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #0d47a1;
    cursor: pointer;
  }
`

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 90vw;
  padding: 0 3%;
  text-align: center;
  position: absolute;
  bottom: 10px;

  @media (min-width: 1300px) {
    padding: 0 10%;
  }

  button {
    width: 80vw;
    height: auto;
    margin: 20px;
    padding: 18px;
    color: #ffffff;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    cursor: pointer;
    border-radius: 16px;
    font-weight: bold;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
    background-image: linear-gradient(
      -45deg,
      #2196f3,
      #0d47a1,
      #0d47a1 50%,
      #2196f3
    );
    &:hover {
      background-image: linear-gradient(
        90deg,
        #0d47a1,
        #2196f3,
        #2196f3 50%,
        #0d47a1
      );
      background-position: -100%;
    }
  }
`

const Instrucoes = styled.div`
  width: 80vw;
  text-align: left;
  margin: 3vh 0 50px 0;
`
